/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    getMonthlyPaymentSchedule({commit}, payload) {
        return new Promise((resolve, reject) => {
            let year_month = '';
            if (payload !== null) {
                year_month = '/' + payload.year + '/' + payload.month;
            }

            axios({url: state.API_URL + '/auth/monthly-payment-schedule' + year_month, method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    prepareInvoice({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/monthly-payment-schedule/prepare-invoice',
                data: payload,
                method: 'POST'
            }).then(({data}) => {
                resolve(data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    generateInvoice({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/monthly-payment-schedule/generate-invoice',
                data: payload,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    sendInvoice({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/monthly-payment-schedule/send-invoice', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    sendInvoiceReminder({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/monthly-payment-schedule/send-invoice-reminder',
                data: payload,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    downloadInvoices({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/monthly-payment-schedule/download-invoices',
                data: payload,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    importCSV({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/monthly-payment-schedule/import-csv', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    exportXML({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/monthly-payment-schedule/export-xml', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    deletePaymentSchedule({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/monthly-payment-schedule/delete', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    setScheduledDate({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/monthly-payment-schedule/set-scheduled-date', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    }
};
